import { useEffect, type ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppFloatingButton } from "./whatsapp/WhatsAppFloatingButton";
import { captureUtmFromLocation } from "@/lib/utm";
import { installZeegSuccessListener } from "@/lib/zeeg";

export function Layout({ children }: { children: ReactNode }) {
  useEffect(() => {
    captureUtmFromLocation();
    installZeegSuccessListener();
  }, []);

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <Header />
      <main id="main" className="flex-1">
        {children}
      </main>
      <Footer />
      <WhatsAppFloatingButton />
    </div>
  );
}
